import { string, shape, number, oneOfType } from 'prop-types';

const ticketCustomerPropTypes = {
  id: number.isRequired,
  firstName: string.isRequired,
  lastName: string.isRequired,
  fullName: string.isRequired,
  idDocumentNumber: string.isRequired,
  idCountryOfOrigin: string,
  identificationTypeId: number.isRequired,
  mobilePhone: string,
  email: string,
  identificationType: shape({
    id: number.isRequired,
    name: string.isRequired,
  }),
};

const itineraryServiceTypePropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  description: string,
};

const ticketReassignmentBasicInformationPropTypes = {
  id: number.isRequired,
  ticketId: number.isRequired,
  ticketDocumentCorrelation: string.isRequired,

  previousTicketAmount: oneOfType([number, string]),
  ticketAmount: number.isRequired,
  ticketStatus: string.isRequired,

  customer: shape(ticketCustomerPropTypes).isRequired,

  previousItineraryId: number,
  previousSeatNumber: number,

  newItineraryId: number,
  newDepartureTime: number,

  newItineraryServiceType: shape(itineraryServiceTypePropTypes),

  newSeatNumber: number,

  userId: oneOfType([number, string]),
  serviceMergeId: number,

  createDate: number,

  previousSourceLocationId: number,
  previousSourceLocationName: string,
  previousDestinationLocationId: number,
  previousDestinationLocationName: string,

  newSourceLocationId: number,
  newSourceLocationName: string,
  newDestinationLocationId: number,
  newDestinationLocationName: string,

  acceptMerge: string,
  negotiation: string,
  refundType: string,
  comment: string,
};

const ticketReassignmentBasicInformationDefaultProps = {
  previousTicketAmount: null,
  userId: null,
  acceptMerge: null,
  negotiation: null,
  refundType: null,
  comment: null,
};

export {
  ticketCustomerPropTypes,
  itineraryServiceTypePropTypes,
  ticketReassignmentBasicInformationPropTypes,
  ticketReassignmentBasicInformationDefaultProps,
};
